import $http from '@/libs/axios'

class CampaignChannelsApi {
  static async list() {
    return (await $http.get('/marketing/channels')).data
  }

  static async remove(id: number) {
    return (await $http.delete(`/marketing/channels/${id}`)).data
  }

  static async process(data: any) {
    return (await $http.post('/marketing/channels/process', data)).data
  }
}

export default CampaignChannelsApi
